jQuery(function($) {
  var $jq = jQuery.noConflict();
  $('.image-text-slideshow [data-slider]').slick({
    slidesToShow: 2,
    prevArrow: '<button class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"><path d="M15 6L9 12L15 18" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true
        }
      }
    ]
  });
  $('.collection-scrollbar[data-slider]').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-arrow slick-prev"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 15.1953L6.83594 8.32031L0 1.44531L1.48438 0L9.80469 8.32031L1.48438 16.6406L0 15.1953Z" fill="#6E5FA5"/></svg></button>',
    nextArrow: '<button class="slick-arrow slick-next"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 15.1953L6.83594 8.32031L0 1.44531L1.48438 0L9.80469 8.32031L1.48438 16.6406L0 15.1953Z" fill="#6E5FA5"/></svg></button>',
    dots: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.giving-page-slide_wrapper[data-slider]').slick({
    slidesToShow: 5,
    autoplay: false,
    responsive: [
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          dots: false,
        }
      }
    ]
  });
  $('.giving-products-carousel[data-slider]').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-arrow slick-prev"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 15.1953L6.83594 8.32031L0 1.44531L1.48438 0L9.80469 8.32031L1.48438 16.6406L0 15.1953Z" fill="#6E5FA5"/></svg></button>',
    nextArrow: '<button class="slick-arrow slick-next"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 15.1953L6.83594 8.32031L0 1.44531L1.48438 0L9.80469 8.32031L1.48438 16.6406L0 15.1953Z" fill="#6E5FA5"/></svg></button>',
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2,
          dots: true
        }
      }
    ]
  });
  $('.press-desc-slider[data-slider]').slick({
    slidesToShow: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000
  }).on('beforeChange', function(event, count, currentSlide, nextSlide) {
    $(".press-logo .press-logo-item.active").removeClass('active');
    $(".press-logo .press-logo-item").eq(nextSlide).addClass('active');
  })

  $(".press-logo .press-logo-item").on('click', function() {
    $(".press-logo .press-logo-item.active").removeClass('active');
    var idx = $(this).index();
    $('.press-desc-slider[data-slider]').slick('slickGoTo', idx);
  })

  if(jQuery(window).width() < 768) {
    $(".press-logo--carousel").slick({
      slidesToShow: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 3000,
      // adaptiveHeight: true
    })
  }

})
